import { css } from '@emotion/react';

export default css({
  '&.truncated-flex': {
    display: 'flex',
    flexWrap: 'wrap',
  },
});
